import React from 'react';
import FormDataProvider from 'integrations/contexts/FormDataProvider';

import { SidebarProvider } from './context/Sidebar';
import { StepsProvider } from './context/Steps';
import { AdvancedOptionsProvider } from './context/AdvancedOptions';
import CrowdStrike from './CrowdStrike';
import INITIAL_FORMDATA from './_initialFormData';

const EmbeddedCrowdStrikeApp = () => (
  <StepsProvider>
    <FormDataProvider initialFormData={INITIAL_FORMDATA}>
      <SidebarProvider>
        <AdvancedOptionsProvider>
          <CrowdStrike externalInputSubmit={false} />
        </AdvancedOptionsProvider>
      </SidebarProvider>
    </FormDataProvider>
  </StepsProvider>
);

export default EmbeddedCrowdStrikeApp;
